// @ts-nocheck
// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { client } from '../client.gen';
import { acceptInvitation, activateUser, addCapaNote, addEcrNote, addNote, addNote2, advanceCapa, advanceEcr, authFinish, authStart, availableCriteria, bulkDownload, bulkSend, bulkValidate, cancelReview, changePassword, checkMyPermissions, checkPermissions, createCapa, createDocumentContainer, createDocumentType, createEcr, createFolder, createInstrument, createPurchaseOrder, createSupplier, createTestRun, createToken, csrfToken, dashboard, dashboard2, deactivateUser, deleteDocumentContainer, deleteDocumentType, deleteDraft, deleteFolder, deleteInstrument, deleteLogo, deleteNote, deletePasskey, deleteSupplier, deleteUser, disable2Fa, downloadOriginal, downloadPdf, editNote, enable2Fa, exportAuditLogs, exportAuditLogs2, failureAnalysis, failureDetails, filterOptions, generate2Fa, getAccessibleResources, getAccessibleUserIds, getCapa, getCapaDashboard, getCapaExport, getCapaPdf, getCapaSettings, getDocumentContainer, getEcr, getEcrDashboard, getEcrExport, getEcrPdf, getFolderContents, getInstrument, getLogo, getMetadata, getMetadata2, getMyAccessibleResources, getMyPermissions, getPowerData, getProfile, getRun, getSettings, getSupplier, getTestRun, getUserPermissions, getUserStatistics, grantPermissions, health, healthDetailed, listActiveUsers, listAuditLogs, listAuditLogs2, listCapaHistory, listCapas, listDocumentContainers, listDocumentTypes, listEcrHistory, listEcrs, listInstruments, listInvitations, listPasskeys, listPdfStatus, listPendingReviews, listPermissions, listRootFolders, listRuns, listSuppliers, listTestRuns, listTokens, listUsers, live, login, login2Fa, logout, macLookup, moveFolder, obsoleteDocument, type Options, passwordRecovery, passwordReset, pdfStatusCount, performanceAnalysis, performanceOverview, powerMetadata, previewPurchaseOrder, ready, reclassifyEcr, recordCalibration, regeneratePdf, registerFinish, registerStart, reinstateDocument, renameFolder, retryAllFailed, revokeInvitation, revokePermissions, revokeToken, search, sendForReview, sendInvitation, streamPowerData, submitReview, suggestCode, timeline, updateCapa, updateCapaSettings, updateDocumentContainer, updateDocumentStatus, updateDocumentType, updateEcr, updateInstrument, updateProfile, updateSettings, updateSupplier, uploadDocument, uploadLogo, uploadPowerData, verifyChain, verifyChain2, version } from '../sdk.gen';
import type { AcceptInvitationData, AcceptInvitationResponse, ActivateUserData, ActivateUserResponse, AddCapaNoteData, AddCapaNoteResponse, AddEcrNoteData, AddEcrNoteResponse, AddNote2Data, AddNote2Response, AddNoteData, AddNoteResponse, AdvanceCapaData, AdvanceCapaResponse, AdvanceEcrData, AdvanceEcrResponse, AuthFinishData, AuthFinishResponse, AuthStartData, AuthStartResponse2, AvailableCriteriaData, AvailableCriteriaResponse, BulkDownloadData, BulkDownloadResponse, BulkSendData, BulkSendResponse2, BulkValidateData, BulkValidateResponse2, CancelReviewData, ChangePasswordData, ChangePasswordResponse, CheckMyPermissionsData, CheckMyPermissionsResponse, CheckPermissionsData, CheckPermissionsResponse, CreateCapaData, CreateCapaResponse, CreateDocumentContainerData, CreateDocumentContainerResponse, CreateDocumentTypeData, CreateDocumentTypeResponse, CreateEcrData, CreateEcrResponse, CreateFolderData, CreateFolderResponse, CreateInstrumentData, CreateInstrumentResponse, CreatePurchaseOrderData, CreatePurchaseOrderResponse, CreateSupplierData, CreateSupplierResponse, CreateTestRunData, CreateTokenData, CreateTokenResponse2, CsrfTokenData, CsrfTokenResponse2, Dashboard2Data, Dashboard2Response, DashboardData, DashboardResponse2, DeactivateUserData, DeactivateUserResponse, DeleteDocumentContainerData, DeleteDocumentContainerResponse, DeleteDocumentTypeData, DeleteDocumentTypeResponse, DeleteDraftData, DeleteFolderData, DeleteFolderResponse, DeleteInstrumentData, DeleteInstrumentResponse, DeleteLogoData, DeleteLogoResponse, DeleteNoteData, DeletePasskeyData, DeleteSupplierData, DeleteUserData, DeleteUserResponse, Disable2FaData, Disable2FaResponse, DownloadOriginalData, DownloadOriginalResponse, DownloadPdfData, DownloadPdfResponse, EditNoteData, EditNoteResponse, Enable2FaData, Enable2FaResponse, ExportAuditLogs2Data, ExportAuditLogsData, FailureAnalysisData, FailureAnalysisResponse2, FailureDetailsData, FailureDetailsResponse2, FilterOptionsData, FilterOptionsResponse2, Generate2FaData, Generate2FaResponse, GetAccessibleResourcesData, GetAccessibleResourcesResponse, GetAccessibleUserIdsData, GetAccessibleUserIdsResponse, GetCapaDashboardData, GetCapaDashboardResponse, GetCapaData, GetCapaExportData, GetCapaPdfData, GetCapaResponse, GetCapaSettingsData, GetCapaSettingsResponse, GetDocumentContainerData, GetDocumentContainerResponse, GetEcrDashboardData, GetEcrDashboardResponse, GetEcrData, GetEcrExportData, GetEcrPdfData, GetEcrResponse, GetFolderContentsData, GetFolderContentsResponse, GetInstrumentData, GetInstrumentResponse, GetLogoData, GetMetadata2Data, GetMetadata2Response, GetMetadataData, GetMetadataResponse, GetMyAccessibleResourcesData, GetMyAccessibleResourcesResponse, GetMyPermissionsData, GetMyPermissionsResponse, GetPowerDataData, GetPowerDataResponse, GetProfileData, GetProfileResponse, GetRunData, GetRunResponse, GetSettingsData, GetSettingsResponse, GetSupplierData, GetSupplierResponse, GetTestRunData, GetTestRunResponse, GetUserPermissionsData, GetUserPermissionsResponse, GetUserStatisticsData, GetUserStatisticsResponse, GrantPermissionsData, GrantPermissionsResponse, HealthData, HealthDetailedData, HealthResponse2, ListActiveUsersData, ListActiveUsersResponse, ListAuditLogs2Data, ListAuditLogs2Response, ListAuditLogsData, ListAuditLogsResponse, ListCapaHistoryData, ListCapasData, ListCapasResponse, ListDocumentContainersData, ListDocumentContainersResponse, ListDocumentTypesData, ListDocumentTypesResponse, ListEcrHistoryData, ListEcrsData, ListEcrsResponse, ListInstrumentsData, ListInstrumentsResponse, ListInvitationsData, ListInvitationsResponse, ListPasskeysData, ListPasskeysResponse, ListPdfStatusData, ListPdfStatusResponse, ListPendingReviewsData, ListPendingReviewsResponse, ListPermissionsData, ListPermissionsResponse, ListRootFoldersData, ListRootFoldersResponse, ListRunsData, ListRunsResponse, ListSuppliersData, ListSuppliersResponse, ListTestRunsData, ListTestRunsResponse, ListTokensData, ListTokensResponse, ListUsersData, ListUsersResponse, LiveData, LiveResponse2, Login2FaData, Login2FaResponse, LoginData, LoginResponse2, LogoutData, LogoutResponse, MacLookupData, MacLookupResponse2, MoveFolderData, MoveFolderResponse, ObsoleteDocumentData, ObsoleteDocumentResponse, PasswordRecoveryData, PasswordRecoveryResponse, PasswordResetData, PasswordResetResponse, PdfStatusCountData, PdfStatusCountResponse, PerformanceAnalysisData, PerformanceAnalysisResponse2, PerformanceOverviewData, PerformanceOverviewResponse2, PowerMetadataData, PowerMetadataResponse2, PreviewPurchaseOrderData, PreviewPurchaseOrderResponse, ReadyData, ReadyError, ReadyResponse2, ReclassifyEcrData, ReclassifyEcrResponse, RecordCalibrationData, RecordCalibrationResponse, RegeneratePdfData, RegeneratePdfResponse, RegisterFinishData, RegisterFinishResponse, RegisterStartData, RegisterStartResponse2, ReinstateDocumentData, ReinstateDocumentResponse, RenameFolderData, RenameFolderResponse, RetryAllFailedData, RetryAllFailedResponse, RevokeInvitationData, RevokeInvitationResponse, RevokePermissionsData, RevokePermissionsResponse, RevokeTokenData, SearchData, SearchResponse, SendForReviewData, SendForReviewResponse, SendInvitationData, SendInvitationResponse, StreamPowerDataData, SubmitReviewData, SubmitReviewResponse, SuggestCodeData, SuggestCodeResponse2, TimelineData, TimelineResponse2, UpdateCapaData, UpdateCapaResponse, UpdateCapaSettingsData, UpdateCapaSettingsResponse, UpdateDocumentContainerData, UpdateDocumentContainerResponse, UpdateDocumentStatusData, UpdateDocumentStatusResponse, UpdateDocumentTypeData, UpdateDocumentTypeResponse, UpdateEcrData, UpdateEcrResponse, UpdateInstrumentData, UpdateInstrumentResponse, UpdateProfileData, UpdateProfileResponse, UpdateSettingsData, UpdateSettingsResponse, UpdateSupplierData, UpdateSupplierResponse, UploadDocumentData, UploadDocumentResponse, UploadLogoData, UploadLogoResponse, UploadPowerDataData, VerifyChain2Data, VerifyChain2Response, VerifyChainData, VerifyChainResponse, VersionData, VersionResponse2 } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listTestRunsQueryKey = (options?: Options<ListTestRunsData>) => createQueryKey('listTestRuns', options);

/**
 * List test runs with optional filters.
 */
export const listTestRunsOptions = (options?: Options<ListTestRunsData>) => queryOptions<ListTestRunsResponse, AxiosError<DefaultError>, ListTestRunsResponse, ReturnType<typeof listTestRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTestRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTestRunsQueryKey(options)
});

/**
 * Create a new test run.
 */
export const createTestRunMutation = (options?: Partial<Options<CreateTestRunData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateTestRunData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CreateTestRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTestRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const macLookupQueryKey = (options: Options<MacLookupData>) => createQueryKey('macLookup', options);

/**
 * Look up the most recent MAC address for a device.
 */
export const macLookupOptions = (options: Options<MacLookupData>) => queryOptions<MacLookupResponse2, AxiosError<DefaultError>, MacLookupResponse2, ReturnType<typeof macLookupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await macLookup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: macLookupQueryKey(options)
});

export const getTestRunQueryKey = (options: Options<GetTestRunData>) => createQueryKey('getTestRun', options);

/**
 * Get a test run by ID (full detail including data JSONB).
 */
export const getTestRunOptions = (options: Options<GetTestRunData>) => queryOptions<GetTestRunResponse, AxiosError<DefaultError>, GetTestRunResponse, ReturnType<typeof getTestRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTestRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTestRunQueryKey(options)
});

export const getPowerDataQueryKey = (options: Options<GetPowerDataData>) => createQueryKey('getPowerData', options);

/**
 * Get power data metadata for a test run.
 */
export const getPowerDataOptions = (options: Options<GetPowerDataData>) => queryOptions<GetPowerDataResponse, AxiosError<DefaultError>, GetPowerDataResponse, ReturnType<typeof getPowerDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPowerData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPowerDataQueryKey(options)
});

/**
 * Upload power data for a test run.
 */
export const uploadPowerDataMutation = (options?: Partial<Options<UploadPowerDataData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UploadPowerDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<UploadPowerDataData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadPowerData({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTokensQueryKey = (options?: Options<ListTokensData>) => createQueryKey('listTokens', options);

/**
 * List all ATE API tokens.
 */
export const listTokensOptions = (options?: Options<ListTokensData>) => queryOptions<ListTokensResponse, AxiosError<DefaultError>, ListTokensResponse, ReturnType<typeof listTokensQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTokens({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTokensQueryKey(options)
});

/**
 * Create a new ATE API token.
 *
 * The raw token hex is returned **once** in the response and cannot be retrieved again.
 */
export const createTokenMutation = (options?: Partial<Options<CreateTokenData>>): UseMutationOptions<CreateTokenResponse2, AxiosError<DefaultError>, Options<CreateTokenData>> => {
    const mutationOptions: UseMutationOptions<CreateTokenResponse2, AxiosError<DefaultError>, Options<CreateTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke an ATE API token.
 */
export const revokeTokenMutation = (options?: Partial<Options<RevokeTokenData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<RevokeTokenData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<RevokeTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAuditLogsQueryKey = (options?: Options<ListAuditLogsData>) => createQueryKey('listAuditLogs', options);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogsOptions = (options?: Options<ListAuditLogsData>) => queryOptions<ListAuditLogsResponse, AxiosError<DefaultError>, ListAuditLogsResponse, ReturnType<typeof listAuditLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listAuditLogsInfiniteQueryKey = (options?: Options<ListAuditLogsData>): QueryKey<Options<ListAuditLogsData>> => createQueryKey('listAuditLogs', options, true);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogsInfiniteOptions = (options?: Options<ListAuditLogsData>) => infiniteQueryOptions<ListAuditLogsResponse, AxiosError<DefaultError>, InfiniteData<ListAuditLogsResponse>, QueryKey<Options<ListAuditLogsData>>, number | Pick<QueryKey<Options<ListAuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListAuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listAuditLogs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogsInfiniteQueryKey(options)
});

export const exportAuditLogsQueryKey = (options?: Options<ExportAuditLogsData>) => createQueryKey('exportAuditLogs', options);

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogsOptions = (options?: Options<ExportAuditLogsData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof exportAuditLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportAuditLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportAuditLogsQueryKey(options)
});

export const getMetadataQueryKey = (options?: Options<GetMetadataData>) => createQueryKey('getMetadata', options);

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadataOptions = (options?: Options<GetMetadataData>) => queryOptions<GetMetadataResponse, AxiosError<DefaultError>, GetMetadataResponse, ReturnType<typeof getMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetadataQueryKey(options)
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChainMutation = (options?: Partial<Options<VerifyChainData>>): UseMutationOptions<VerifyChainResponse, AxiosError<DefaultError>, Options<VerifyChainData>> => {
    const mutationOptions: UseMutationOptions<VerifyChainResponse, AxiosError<DefaultError>, Options<VerifyChainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyChain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDocumentTypesQueryKey = (options?: Options<ListDocumentTypesData>) => createQueryKey('listDocumentTypes', options);

/**
 * List document types (paginated).
 */
export const listDocumentTypesOptions = (options?: Options<ListDocumentTypesData>) => queryOptions<ListDocumentTypesResponse, AxiosError<DefaultError>, ListDocumentTypesResponse, ReturnType<typeof listDocumentTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDocumentTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentTypesQueryKey(options)
});

export const listDocumentTypesInfiniteQueryKey = (options?: Options<ListDocumentTypesData>): QueryKey<Options<ListDocumentTypesData>> => createQueryKey('listDocumentTypes', options, true);

/**
 * List document types (paginated).
 */
export const listDocumentTypesInfiniteOptions = (options?: Options<ListDocumentTypesData>) => infiniteQueryOptions<ListDocumentTypesResponse, AxiosError<DefaultError>, InfiniteData<ListDocumentTypesResponse>, QueryKey<Options<ListDocumentTypesData>>, number | Pick<QueryKey<Options<ListDocumentTypesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDocumentTypesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDocumentTypes({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentTypesInfiniteQueryKey(options)
});

/**
 * Create a new document type.
 */
export const createDocumentTypeMutation = (options?: Partial<Options<CreateDocumentTypeData>>): UseMutationOptions<CreateDocumentTypeResponse, AxiosError<DefaultError>, Options<CreateDocumentTypeData>> => {
    const mutationOptions: UseMutationOptions<CreateDocumentTypeResponse, AxiosError<DefaultError>, Options<CreateDocumentTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDocumentType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a document type.
 *
 * Fails if any document containers reference this type.
 */
export const deleteDocumentTypeMutation = (options?: Partial<Options<DeleteDocumentTypeData>>): UseMutationOptions<DeleteDocumentTypeResponse, AxiosError<DefaultError>, Options<DeleteDocumentTypeData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentTypeResponse, AxiosError<DefaultError>, Options<DeleteDocumentTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocumentType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a document type.
 */
export const updateDocumentTypeMutation = (options?: Partial<Options<UpdateDocumentTypeData>>): UseMutationOptions<UpdateDocumentTypeResponse, AxiosError<DefaultError>, Options<UpdateDocumentTypeData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentTypeResponse, AxiosError<DefaultError>, Options<UpdateDocumentTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDocumentType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPdfStatusQueryKey = (options?: Options<ListPdfStatusData>) => createQueryKey('listPdfStatus', options);

/**
 * List documents by PDF generation status (admin only).
 *
 * Returns documents that have non-COMPLETED PDF generation, enriched with
 * container info and creator name. Supports pagination, sorting, and filtering.
 */
export const listPdfStatusOptions = (options?: Options<ListPdfStatusData>) => queryOptions<ListPdfStatusResponse, AxiosError<DefaultError>, ListPdfStatusResponse, ReturnType<typeof listPdfStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPdfStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPdfStatusQueryKey(options)
});

export const listPdfStatusInfiniteQueryKey = (options?: Options<ListPdfStatusData>): QueryKey<Options<ListPdfStatusData>> => createQueryKey('listPdfStatus', options, true);

/**
 * List documents by PDF generation status (admin only).
 *
 * Returns documents that have non-COMPLETED PDF generation, enriched with
 * container info and creator name. Supports pagination, sorting, and filtering.
 */
export const listPdfStatusInfiniteOptions = (options?: Options<ListPdfStatusData>) => infiniteQueryOptions<ListPdfStatusResponse, AxiosError<DefaultError>, InfiniteData<ListPdfStatusResponse>, QueryKey<Options<ListPdfStatusData>>, number | Pick<QueryKey<Options<ListPdfStatusData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPdfStatusData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPdfStatus({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPdfStatusInfiniteQueryKey(options)
});

export const pdfStatusCountQueryKey = (options?: Options<PdfStatusCountData>) => createQueryKey('pdfStatusCount', options);

/**
 * Count documents with PENDING or FAILED PDF generation (admin only).
 *
 * Used for the sidebar badge indicator.
 */
export const pdfStatusCountOptions = (options?: Options<PdfStatusCountData>) => queryOptions<PdfStatusCountResponse, AxiosError<DefaultError>, PdfStatusCountResponse, ReturnType<typeof pdfStatusCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await pdfStatusCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pdfStatusCountQueryKey(options)
});

/**
 * Retry PDF generation for all FAILED documents (admin only).
 */
export const retryAllFailedMutation = (options?: Partial<Options<RetryAllFailedData>>): UseMutationOptions<RetryAllFailedResponse, AxiosError<DefaultError>, Options<RetryAllFailedData>> => {
    const mutationOptions: UseMutationOptions<RetryAllFailedResponse, AxiosError<DefaultError>, Options<RetryAllFailedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryAllFailed({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInvitationsQueryKey = (options?: Options<ListInvitationsData>) => createQueryKey('listInvitations', options);

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitationsOptions = (options?: Options<ListInvitationsData>) => queryOptions<ListInvitationsResponse, AxiosError<DefaultError>, ListInvitationsResponse, ReturnType<typeof listInvitationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvitations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvitationsQueryKey(options)
});

export const listInvitationsInfiniteQueryKey = (options?: Options<ListInvitationsData>): QueryKey<Options<ListInvitationsData>> => createQueryKey('listInvitations', options, true);

/**
 * List all invitations (paginated).
 *
 * Returns active (non-archived) invitations sorted by `created_at` descending.
 * Supports text search on email and status filter (`pending`, `accepted`, `expired`).
 */
export const listInvitationsInfiniteOptions = (options?: Options<ListInvitationsData>) => infiniteQueryOptions<ListInvitationsResponse, AxiosError<DefaultError>, InfiniteData<ListInvitationsResponse>, QueryKey<Options<ListInvitationsData>>, number | Pick<QueryKey<Options<ListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListInvitationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInvitations({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvitationsInfiniteQueryKey(options)
});

/**
 * Send a single invitation.
 *
 * Creates an invitation record for the given email address. The email must not
 * already be registered as a user or have an active (non-archived, non-expired)
 * invitation. Returns a message on success.
 */
export const sendInvitationMutation = (options?: Partial<Options<SendInvitationData>>): UseMutationOptions<SendInvitationResponse, AxiosError<DefaultError>, Options<SendInvitationData>> => {
    const mutationOptions: UseMutationOptions<SendInvitationResponse, AxiosError<DefaultError>, Options<SendInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send bulk invitations.
 *
 * Attempts to create an invitation for each email address. Emails that are
 * already registered or already have active invitations are skipped and
 * reported in the `failed` map.
 */
export const bulkSendMutation = (options?: Partial<Options<BulkSendData>>): UseMutationOptions<BulkSendResponse2, AxiosError<DefaultError>, Options<BulkSendData>> => {
    const mutationOptions: UseMutationOptions<BulkSendResponse2, AxiosError<DefaultError>, Options<BulkSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate emails for bulk invitation.
 *
 * For each email, checks format validity, whether it is already registered,
 * and whether an active invitation already exists. Returns categorized results.
 */
export const bulkValidateMutation = (options?: Partial<Options<BulkValidateData>>): UseMutationOptions<BulkValidateResponse2, AxiosError<DefaultError>, Options<BulkValidateData>> => {
    const mutationOptions: UseMutationOptions<BulkValidateResponse2, AxiosError<DefaultError>, Options<BulkValidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkValidate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke (archive) an invitation.
 *
 * Soft-deletes the invitation by setting `archived_at` and `archived_by_id`.
 * Returns a message on success.
 */
export const revokeInvitationMutation = (options?: Partial<Options<RevokeInvitationData>>): UseMutationOptions<RevokeInvitationResponse, AxiosError<DefaultError>, Options<RevokeInvitationData>> => {
    const mutationOptions: UseMutationOptions<RevokeInvitationResponse, AxiosError<DefaultError>, Options<RevokeInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUsersQueryKey = (options?: Options<ListUsersData>) => createQueryKey('listUsers', options);

/**
 * List all users (admin only).
 *
 * Returns a paginated list of users with optional search and active-status filtering.
 */
export const listUsersOptions = (options?: Options<ListUsersData>) => queryOptions<ListUsersResponse, AxiosError<DefaultError>, ListUsersResponse, ReturnType<typeof listUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersQueryKey(options)
});

export const listUsersInfiniteQueryKey = (options?: Options<ListUsersData>): QueryKey<Options<ListUsersData>> => createQueryKey('listUsers', options, true);

/**
 * List all users (admin only).
 *
 * Returns a paginated list of users with optional search and active-status filtering.
 */
export const listUsersInfiniteOptions = (options?: Options<ListUsersData>) => infiniteQueryOptions<ListUsersResponse, AxiosError<DefaultError>, InfiniteData<ListUsersResponse>, QueryKey<Options<ListUsersData>>, number | Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersInfiniteQueryKey(options)
});

/**
 * Delete or archive a user (admin only).
 *
 * Hard-deletes the specified user.
 * Cannot delete yourself. Cannot delete the last admin.
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<DeleteUserResponse, AxiosError<DefaultError>, Options<DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserResponse, AxiosError<DefaultError>, Options<DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Activate a user (admin only).
 *
 * Sets the user's `is_active` flag to `true`.
 */
export const activateUserMutation = (options?: Partial<Options<ActivateUserData>>): UseMutationOptions<ActivateUserResponse, AxiosError<DefaultError>, Options<ActivateUserData>> => {
    const mutationOptions: UseMutationOptions<ActivateUserResponse, AxiosError<DefaultError>, Options<ActivateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await activateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate a user (admin only).
 *
 * Sets the user's `is_active` flag to `false`. Cannot deactivate yourself.
 */
export const deactivateUserMutation = (options?: Partial<Options<DeactivateUserData>>): UseMutationOptions<DeactivateUserResponse, AxiosError<DefaultError>, Options<DeactivateUserData>> => {
    const mutationOptions: UseMutationOptions<DeactivateUserResponse, AxiosError<DefaultError>, Options<DeactivateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deactivateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserStatisticsQueryKey = (options: Options<GetUserStatisticsData>) => createQueryKey('getUserStatistics', options);

/**
 * Get user activity statistics (admin only).
 *
 * Returns audit activity counts and account age for a specific user.
 */
export const getUserStatisticsOptions = (options: Options<GetUserStatisticsData>) => queryOptions<GetUserStatisticsResponse, AxiosError<DefaultError>, GetUserStatisticsResponse, ReturnType<typeof getUserStatisticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserStatistics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserStatisticsQueryKey(options)
});

export const dashboardQueryKey = (options?: Options<DashboardData>) => createQueryKey('dashboard', options);

/**
 * Dashboard with aggregate stats and recent runs.
 */
export const dashboardOptions = (options?: Options<DashboardData>) => queryOptions<DashboardResponse2, AxiosError<DefaultError>, DashboardResponse2, ReturnType<typeof dashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboardQueryKey(options)
});

export const failureAnalysisQueryKey = (options?: Options<FailureAnalysisData>) => createQueryKey('failureAnalysis', options);

/**
 * Failure analysis: aggregated failure statistics with yield, severity, period comparison.
 */
export const failureAnalysisOptions = (options?: Options<FailureAnalysisData>) => queryOptions<FailureAnalysisResponse2, AxiosError<DefaultError>, FailureAnalysisResponse2, ReturnType<typeof failureAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await failureAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: failureAnalysisQueryKey(options)
});

export const failureDetailsQueryKey = (options: Options<FailureDetailsData>) => createQueryKey('failureDetails', options);

/**
 * Failure details for a specific criterion with server-side pagination.
 */
export const failureDetailsOptions = (options: Options<FailureDetailsData>) => queryOptions<FailureDetailsResponse2, AxiosError<DefaultError>, FailureDetailsResponse2, ReturnType<typeof failureDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await failureDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: failureDetailsQueryKey(options)
});

export const failureDetailsInfiniteQueryKey = (options: Options<FailureDetailsData>): QueryKey<Options<FailureDetailsData>> => createQueryKey('failureDetails', options, true);

/**
 * Failure details for a specific criterion with server-side pagination.
 */
export const failureDetailsInfiniteOptions = (options: Options<FailureDetailsData>) => infiniteQueryOptions<FailureDetailsResponse2, AxiosError<DefaultError>, InfiniteData<FailureDetailsResponse2>, QueryKey<Options<FailureDetailsData>>, number | null | Pick<QueryKey<Options<FailureDetailsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<FailureDetailsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await failureDetails({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: failureDetailsInfiniteQueryKey(options)
});

export const filterOptionsQueryKey = (options?: Options<FilterOptionsData>) => createQueryKey('filterOptions', options);

export const filterOptionsOptions = (options?: Options<FilterOptionsData>) => queryOptions<FilterOptionsResponse2, AxiosError<DefaultError>, FilterOptionsResponse2, ReturnType<typeof filterOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await filterOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: filterOptionsQueryKey(options)
});

export const performanceAnalysisQueryKey = (options: Options<PerformanceAnalysisData>) => createQueryKey('performanceAnalysis', options);

/**
 * Performance analysis: time-series data with spec limits, Cp/Cpk, yield.
 */
export const performanceAnalysisOptions = (options: Options<PerformanceAnalysisData>) => queryOptions<PerformanceAnalysisResponse2, AxiosError<DefaultError>, PerformanceAnalysisResponse2, ReturnType<typeof performanceAnalysisQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await performanceAnalysis({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: performanceAnalysisQueryKey(options)
});

export const availableCriteriaQueryKey = (options?: Options<AvailableCriteriaData>) => createQueryKey('availableCriteria', options);

/**
 * List available criteria for performance analysis (with unit + type).
 */
export const availableCriteriaOptions = (options?: Options<AvailableCriteriaData>) => queryOptions<AvailableCriteriaResponse, AxiosError<DefaultError>, AvailableCriteriaResponse, ReturnType<typeof availableCriteriaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await availableCriteria({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: availableCriteriaQueryKey(options)
});

export const performanceOverviewQueryKey = (options?: Options<PerformanceOverviewData>) => createQueryKey('performanceOverview', options);

/**
 * Performance overview: aggregated metrics for all criteria.
 */
export const performanceOverviewOptions = (options?: Options<PerformanceOverviewData>) => queryOptions<PerformanceOverviewResponse2, AxiosError<DefaultError>, PerformanceOverviewResponse2, ReturnType<typeof performanceOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await performanceOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: performanceOverviewQueryKey(options)
});

export const listRunsQueryKey = (options?: Options<ListRunsData>) => createQueryKey('listRuns', options);

/**
 * Paginated test run listing with filters.
 */
export const listRunsOptions = (options?: Options<ListRunsData>) => queryOptions<ListRunsResponse, AxiosError<DefaultError>, ListRunsResponse, ReturnType<typeof listRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRunsQueryKey(options)
});

export const listRunsInfiniteQueryKey = (options?: Options<ListRunsData>): QueryKey<Options<ListRunsData>> => createQueryKey('listRuns', options, true);

/**
 * Paginated test run listing with filters.
 */
export const listRunsInfiniteOptions = (options?: Options<ListRunsData>) => infiniteQueryOptions<ListRunsResponse, AxiosError<DefaultError>, InfiniteData<ListRunsResponse>, QueryKey<Options<ListRunsData>>, number | Pick<QueryKey<Options<ListRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listRuns({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRunsInfiniteQueryKey(options)
});

export const getRunQueryKey = (options: Options<GetRunData>) => createQueryKey('getRun', options);

/**
 * Get a test run by ID (full detail).
 */
export const getRunOptions = (options: Options<GetRunData>) => queryOptions<GetRunResponse, AxiosError<DefaultError>, GetRunResponse, ReturnType<typeof getRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRunQueryKey(options)
});

export const streamPowerDataQueryKey = (options: Options<StreamPowerDataData>) => createQueryKey('streamPowerData', options);

/**
 * Stream power data binary (download from Azure, strip PCOC header).
 */
export const streamPowerDataOptions = (options: Options<StreamPowerDataData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof streamPowerDataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await streamPowerData({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: streamPowerDataQueryKey(options)
});

export const powerMetadataQueryKey = (options: Options<PowerMetadataData>) => createQueryKey('powerMetadata', options);

/**
 * Power metadata with phase markers extracted from test sequences.
 */
export const powerMetadataOptions = (options: Options<PowerMetadataData>) => queryOptions<PowerMetadataResponse2, AxiosError<DefaultError>, PowerMetadataResponse2, ReturnType<typeof powerMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await powerMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: powerMetadataQueryKey(options)
});

export const timelineQueryKey = (options?: Options<TimelineData>) => createQueryKey('timeline', options);

/**
 * Daily test counts for the full history (used for timeline brush chart).
 */
export const timelineOptions = (options?: Options<TimelineData>) => queryOptions<TimelineResponse2, AxiosError<DefaultError>, TimelineResponse2, ReturnType<typeof timelineQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await timeline({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: timelineQueryKey(options)
});

export const listAuditLogs2QueryKey = (options?: Options<ListAuditLogs2Data>) => createQueryKey('listAuditLogs2', options);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2Options = (options?: Options<ListAuditLogs2Data>) => queryOptions<ListAuditLogs2Response, AxiosError<DefaultError>, ListAuditLogs2Response, ReturnType<typeof listAuditLogs2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAuditLogs2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogs2QueryKey(options)
});

export const listAuditLogs2InfiniteQueryKey = (options?: Options<ListAuditLogs2Data>): QueryKey<Options<ListAuditLogs2Data>> => createQueryKey('listAuditLogs2', options, true);

/**
 * List audit logs with pagination and optional filters.
 *
 * Supports filtering by action, resource type, resource ID, severity,
 * date range, and user search. Filters accept comma-separated values
 * for multi-value matching. Combined with standard `ListParams` pagination.
 */
export const listAuditLogs2InfiniteOptions = (options?: Options<ListAuditLogs2Data>) => infiniteQueryOptions<ListAuditLogs2Response, AxiosError<DefaultError>, InfiniteData<ListAuditLogs2Response>, QueryKey<Options<ListAuditLogs2Data>>, number | Pick<QueryKey<Options<ListAuditLogs2Data>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListAuditLogs2Data>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listAuditLogs2({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAuditLogs2InfiniteQueryKey(options)
});

export const exportAuditLogs2QueryKey = (options?: Options<ExportAuditLogs2Data>) => createQueryKey('exportAuditLogs2', options);

/**
 * Export audit logs as a JSON file download.
 *
 * Applies the same filters as `list_audit_logs` but returns ALL matching
 * rows (no pagination) as a downloadable JSON attachment.
 */
export const exportAuditLogs2Options = (options?: Options<ExportAuditLogs2Data>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof exportAuditLogs2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportAuditLogs2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportAuditLogs2QueryKey(options)
});

export const getMetadata2QueryKey = (options?: Options<GetMetadata2Data>) => createQueryKey('getMetadata2', options);

/**
 * Get available filter metadata for audit log UI controls.
 *
 * Returns lists of valid actions, resource types, and severity levels
 * that can be used in filter dropdowns.
 */
export const getMetadata2Options = (options?: Options<GetMetadata2Data>) => queryOptions<GetMetadata2Response, AxiosError<DefaultError>, GetMetadata2Response, ReturnType<typeof getMetadata2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetadata2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetadata2QueryKey(options)
});

/**
 * Verify the integrity of the entire audit hash chain.
 *
 * Loads all audit log entries and verifies each entry's HMAC signature
 * plus the hash chain linking consecutive entries.
 */
export const verifyChain2Mutation = (options?: Partial<Options<VerifyChain2Data>>): UseMutationOptions<VerifyChain2Response, AxiosError<DefaultError>, Options<VerifyChain2Data>> => {
    const mutationOptions: UseMutationOptions<VerifyChain2Response, AxiosError<DefaultError>, Options<VerifyChain2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verifyChain2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept an invitation and create a new user account.
 */
export const acceptInvitationMutation = (options?: Partial<Options<AcceptInvitationData>>): UseMutationOptions<AcceptInvitationResponse, AxiosError<DefaultError>, Options<AcceptInvitationData>> => {
    const mutationOptions: UseMutationOptions<AcceptInvitationResponse, AxiosError<DefaultError>, Options<AcceptInvitationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptInvitation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Authenticate and receive a JWT token.
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse2, AxiosError<DefaultError>, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse2, AxiosError<DefaultError>, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete two-factor authentication login.
 */
export const login2FaMutation = (options?: Partial<Options<Login2FaData>>): UseMutationOptions<Login2FaResponse, AxiosError<DefaultError>, Options<Login2FaData>> => {
    const mutationOptions: UseMutationOptions<Login2FaResponse, AxiosError<DefaultError>, Options<Login2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Log out the current user by blacklisting their token.
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, AxiosError<DefaultError>, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, AxiosError<DefaultError>, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProfileQueryKey = (options?: Options<GetProfileData>) => createQueryKey('getProfile', options);

/**
 * Get the current authenticated user's profile.
 */
export const getProfileOptions = (options?: Options<GetProfileData>) => queryOptions<GetProfileResponse, AxiosError<DefaultError>, GetProfileResponse, ReturnType<typeof getProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProfileQueryKey(options)
});

/**
 * Complete passkey authentication and issue a JWT.
 */
export const authFinishMutation = (options?: Partial<Options<AuthFinishData>>): UseMutationOptions<AuthFinishResponse, AxiosError<DefaultError>, Options<AuthFinishData>> => {
    const mutationOptions: UseMutationOptions<AuthFinishResponse, AxiosError<DefaultError>, Options<AuthFinishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authFinish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start passkey authentication.
 *
 * Accepts the user's email. If the user has registered passkeys, returns
 * `WebAuthn` request options with `allowCredentials` populated so that
 * password managers can match the credential. If the user has no passkeys
 * (or the email is unknown), returns `{ has_passkeys: false }` without
 * revealing whether the email exists.
 */
export const authStartMutation = (options?: Partial<Options<AuthStartData>>): UseMutationOptions<AuthStartResponse2, AxiosError<DefaultError>, Options<AuthStartData>> => {
    const mutationOptions: UseMutationOptions<AuthStartResponse2, AxiosError<DefaultError>, Options<AuthStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Request a password reset email.
 *
 * Always returns success to prevent email enumeration.
 */
export const passwordRecoveryMutation = (options?: Partial<Options<PasswordRecoveryData>>): UseMutationOptions<PasswordRecoveryResponse, AxiosError<DefaultError>, Options<PasswordRecoveryData>> => {
    const mutationOptions: UseMutationOptions<PasswordRecoveryResponse, AxiosError<DefaultError>, Options<PasswordRecoveryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passwordRecovery({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reset password using a token received via email.
 */
export const passwordResetMutation = (options?: Partial<Options<PasswordResetData>>): UseMutationOptions<PasswordResetResponse, AxiosError<DefaultError>, Options<PasswordResetData>> => {
    const mutationOptions: UseMutationOptions<PasswordResetResponse, AxiosError<DefaultError>, Options<PasswordResetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await passwordReset({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInstrumentsQueryKey = (options?: Options<ListInstrumentsData>) => createQueryKey('listInstruments', options);

/**
 * List calibration instruments (paginated, searchable, filterable).
 */
export const listInstrumentsOptions = (options?: Options<ListInstrumentsData>) => queryOptions<ListInstrumentsResponse, AxiosError<DefaultError>, ListInstrumentsResponse, ReturnType<typeof listInstrumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInstruments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInstrumentsQueryKey(options)
});

export const listInstrumentsInfiniteQueryKey = (options?: Options<ListInstrumentsData>): QueryKey<Options<ListInstrumentsData>> => createQueryKey('listInstruments', options, true);

/**
 * List calibration instruments (paginated, searchable, filterable).
 */
export const listInstrumentsInfiniteOptions = (options?: Options<ListInstrumentsData>) => infiniteQueryOptions<ListInstrumentsResponse, AxiosError<DefaultError>, InfiniteData<ListInstrumentsResponse>, QueryKey<Options<ListInstrumentsData>>, number | Pick<QueryKey<Options<ListInstrumentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListInstrumentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInstruments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInstrumentsInfiniteQueryKey(options)
});

/**
 * Create a calibration instrument.
 */
export const createInstrumentMutation = (options?: Partial<Options<CreateInstrumentData>>): UseMutationOptions<CreateInstrumentResponse, AxiosError<DefaultError>, Options<CreateInstrumentData>> => {
    const mutationOptions: UseMutationOptions<CreateInstrumentResponse, AxiosError<DefaultError>, Options<CreateInstrumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createInstrument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dashboard2QueryKey = (options?: Options<Dashboard2Data>) => createQueryKey('dashboard2', options);

/**
 * Get dashboard statistics.
 */
export const dashboard2Options = (options?: Options<Dashboard2Data>) => queryOptions<Dashboard2Response, AxiosError<DefaultError>, Dashboard2Response, ReturnType<typeof dashboard2QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await dashboard2({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: dashboard2QueryKey(options)
});

/**
 * Delete an instrument (sets status to `OUT_OF_SERVICE`).
 */
export const deleteInstrumentMutation = (options?: Partial<Options<DeleteInstrumentData>>): UseMutationOptions<DeleteInstrumentResponse, AxiosError<DefaultError>, Options<DeleteInstrumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteInstrumentResponse, AxiosError<DefaultError>, Options<DeleteInstrumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInstrument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInstrumentQueryKey = (options: Options<GetInstrumentData>) => createQueryKey('getInstrument', options);

/**
 * Get instrument by ID with calibration history.
 */
export const getInstrumentOptions = (options: Options<GetInstrumentData>) => queryOptions<GetInstrumentResponse, AxiosError<DefaultError>, GetInstrumentResponse, ReturnType<typeof getInstrumentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstrument({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstrumentQueryKey(options)
});

/**
 * Update an instrument.
 */
export const updateInstrumentMutation = (options?: Partial<Options<UpdateInstrumentData>>): UseMutationOptions<UpdateInstrumentResponse, AxiosError<DefaultError>, Options<UpdateInstrumentData>> => {
    const mutationOptions: UseMutationOptions<UpdateInstrumentResponse, AxiosError<DefaultError>, Options<UpdateInstrumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateInstrument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a note to an instrument's history.
 */
export const addNoteMutation = (options?: Partial<Options<AddNoteData>>): UseMutationOptions<AddNoteResponse, AxiosError<DefaultError>, Options<AddNoteData>> => {
    const mutationOptions: UseMutationOptions<AddNoteResponse, AxiosError<DefaultError>, Options<AddNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record a calibration event.
 *
 * Updates `last_calibrated`, recalculates due date, and updates certificate reference.
 */
export const recordCalibrationMutation = (options?: Partial<Options<RecordCalibrationData>>): UseMutationOptions<RecordCalibrationResponse, AxiosError<DefaultError>, Options<RecordCalibrationData>> => {
    const mutationOptions: UseMutationOptions<RecordCalibrationResponse, AxiosError<DefaultError>, Options<RecordCalibrationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recordCalibration({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCapasQueryKey = (options?: Options<ListCapasData>) => createQueryKey('listCapas', options);

/**
 * List CAPAs with pagination, search, and filters.
 */
export const listCapasOptions = (options?: Options<ListCapasData>) => queryOptions<ListCapasResponse, AxiosError<DefaultError>, ListCapasResponse, ReturnType<typeof listCapasQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCapas({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapasQueryKey(options)
});

export const listCapasInfiniteQueryKey = (options?: Options<ListCapasData>): QueryKey<Options<ListCapasData>> => createQueryKey('listCapas', options, true);

/**
 * List CAPAs with pagination, search, and filters.
 */
export const listCapasInfiniteOptions = (options?: Options<ListCapasData>) => infiniteQueryOptions<ListCapasResponse, AxiosError<DefaultError>, InfiniteData<ListCapasResponse>, QueryKey<Options<ListCapasData>>, number | Pick<QueryKey<Options<ListCapasData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCapasData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCapas({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapasInfiniteQueryKey(options)
});

/**
 * Create a new CAPA.
 */
export const createCapaMutation = (options?: Partial<Options<CreateCapaData>>): UseMutationOptions<CreateCapaResponse, AxiosError<DefaultError>, Options<CreateCapaData>> => {
    const mutationOptions: UseMutationOptions<CreateCapaResponse, AxiosError<DefaultError>, Options<CreateCapaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCapa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCapaDashboardQueryKey = (options?: Options<GetCapaDashboardData>) => createQueryKey('getCapaDashboard', options);

/**
 * Get CAPA dashboard data.
 */
export const getCapaDashboardOptions = (options?: Options<GetCapaDashboardData>) => queryOptions<GetCapaDashboardResponse, AxiosError<DefaultError>, GetCapaDashboardResponse, ReturnType<typeof getCapaDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapaDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapaDashboardQueryKey(options)
});

export const getCapaExportQueryKey = (options?: Options<GetCapaExportData>) => createQueryKey('getCapaExport', options);

/**
 * Export CAPAs as CSV or JSON.
 */
export const getCapaExportOptions = (options?: Options<GetCapaExportData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getCapaExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapaExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapaExportQueryKey(options)
});

export const getCapaSettingsQueryKey = (options?: Options<GetCapaSettingsData>) => createQueryKey('getCapaSettings', options);

/**
 * Get CAPA settings.
 */
export const getCapaSettingsOptions = (options?: Options<GetCapaSettingsData>) => queryOptions<GetCapaSettingsResponse, AxiosError<DefaultError>, GetCapaSettingsResponse, ReturnType<typeof getCapaSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapaSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapaSettingsQueryKey(options)
});

/**
 * Update CAPA settings (admin only).
 */
export const updateCapaSettingsMutation = (options?: Partial<Options<UpdateCapaSettingsData>>): UseMutationOptions<UpdateCapaSettingsResponse, AxiosError<DefaultError>, Options<UpdateCapaSettingsData>> => {
    const mutationOptions: UseMutationOptions<UpdateCapaSettingsResponse, AxiosError<DefaultError>, Options<UpdateCapaSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCapaSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCapaQueryKey = (options: Options<GetCapaData>) => createQueryKey('getCapa', options);

/**
 * Get CAPA detail with history.
 */
export const getCapaOptions = (options: Options<GetCapaData>) => queryOptions<GetCapaResponse, AxiosError<DefaultError>, GetCapaResponse, ReturnType<typeof getCapaQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapa({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapaQueryKey(options)
});

/**
 * Update CAPA fields with diff tracking.
 */
export const updateCapaMutation = (options?: Partial<Options<UpdateCapaData>>): UseMutationOptions<UpdateCapaResponse, AxiosError<DefaultError>, Options<UpdateCapaData>> => {
    const mutationOptions: UseMutationOptions<UpdateCapaResponse, AxiosError<DefaultError>, Options<UpdateCapaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCapa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Advance CAPA through workflow stages.
 */
export const advanceCapaMutation = (options?: Partial<Options<AdvanceCapaData>>): UseMutationOptions<AdvanceCapaResponse, AxiosError<DefaultError>, Options<AdvanceCapaData>> => {
    const mutationOptions: UseMutationOptions<AdvanceCapaResponse, AxiosError<DefaultError>, Options<AdvanceCapaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await advanceCapa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCapaHistoryQueryKey = (options: Options<ListCapaHistoryData>) => createQueryKey('listCapaHistory', options);

/**
 * List history entries for a CAPA (newest first).
 */
export const listCapaHistoryOptions = (options: Options<ListCapaHistoryData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof listCapaHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCapaHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapaHistoryQueryKey(options)
});

export const listCapaHistoryInfiniteQueryKey = (options: Options<ListCapaHistoryData>): QueryKey<Options<ListCapaHistoryData>> => createQueryKey('listCapaHistory', options, true);

/**
 * List history entries for a CAPA (newest first).
 */
export const listCapaHistoryInfiniteOptions = (options: Options<ListCapaHistoryData>) => infiniteQueryOptions<unknown, AxiosError<DefaultError>, InfiniteData<unknown>, QueryKey<Options<ListCapaHistoryData>>, number | Pick<QueryKey<Options<ListCapaHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCapaHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCapaHistory({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCapaHistoryInfiniteQueryKey(options)
});

/**
 * Add a note to a CAPA's history.
 */
export const addCapaNoteMutation = (options?: Partial<Options<AddCapaNoteData>>): UseMutationOptions<AddCapaNoteResponse, AxiosError<DefaultError>, Options<AddCapaNoteData>> => {
    const mutationOptions: UseMutationOptions<AddCapaNoteResponse, AxiosError<DefaultError>, Options<AddCapaNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addCapaNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCapaPdfQueryKey = (options: Options<GetCapaPdfData>) => createQueryKey('getCapaPdf', options);

/**
 * Export a single CAPA as PDF.
 */
export const getCapaPdfOptions = (options: Options<GetCapaPdfData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getCapaPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCapaPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCapaPdfQueryKey(options)
});

export const csrfTokenQueryKey = (options?: Options<CsrfTokenData>) => createQueryKey('csrfToken', options);

/**
 * Generate a CSRF token.
 *
 * Returns an HMAC-signed CSRF token in the format `{timestamp}:{random_hex}:{signature}`.
 * Returns an HMAC-signed CSRF token.
 *
 * - `timestamp` — Unix epoch seconds
 * - `random_hex` — 16 random bytes, hex-encoded (32 chars)
 * - `signature` — HMAC-SHA256 of `{timestamp}:{random_hex}`, hex-encoded (64 chars)
 */
export const csrfTokenOptions = (options?: Options<CsrfTokenData>) => queryOptions<CsrfTokenResponse2, AxiosError<DefaultError>, CsrfTokenResponse2, ReturnType<typeof csrfTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await csrfToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: csrfTokenQueryKey(options)
});

export const listDocumentContainersQueryKey = (options?: Options<ListDocumentContainersData>) => createQueryKey('listDocumentContainers', options);

/**
 * List document containers (paginated, with search).
 */
export const listDocumentContainersOptions = (options?: Options<ListDocumentContainersData>) => queryOptions<ListDocumentContainersResponse, AxiosError<DefaultError>, ListDocumentContainersResponse, ReturnType<typeof listDocumentContainersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDocumentContainers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentContainersQueryKey(options)
});

export const listDocumentContainersInfiniteQueryKey = (options?: Options<ListDocumentContainersData>): QueryKey<Options<ListDocumentContainersData>> => createQueryKey('listDocumentContainers', options, true);

/**
 * List document containers (paginated, with search).
 */
export const listDocumentContainersInfiniteOptions = (options?: Options<ListDocumentContainersData>) => infiniteQueryOptions<ListDocumentContainersResponse, AxiosError<DefaultError>, InfiniteData<ListDocumentContainersResponse>, QueryKey<Options<ListDocumentContainersData>>, number | Pick<QueryKey<Options<ListDocumentContainersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDocumentContainersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDocumentContainers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDocumentContainersInfiniteQueryKey(options)
});

/**
 * Create a new document container.
 *
 * Auto-generates a unique document number using the `PostgreSQL` sequence.
 */
export const createDocumentContainerMutation = (options?: Partial<Options<CreateDocumentContainerData>>): UseMutationOptions<CreateDocumentContainerResponse, AxiosError<DefaultError>, Options<CreateDocumentContainerData>> => {
    const mutationOptions: UseMutationOptions<CreateDocumentContainerResponse, AxiosError<DefaultError>, Options<CreateDocumentContainerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDocumentContainer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a document container.
 *
 * Fails if any documents exist in the container.
 */
export const deleteDocumentContainerMutation = (options?: Partial<Options<DeleteDocumentContainerData>>): UseMutationOptions<DeleteDocumentContainerResponse, AxiosError<DefaultError>, Options<DeleteDocumentContainerData>> => {
    const mutationOptions: UseMutationOptions<DeleteDocumentContainerResponse, AxiosError<DefaultError>, Options<DeleteDocumentContainerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDocumentContainer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDocumentContainerQueryKey = (options: Options<GetDocumentContainerData>) => createQueryKey('getDocumentContainer', options);

/**
 * Get document container detail with documents list.
 *
 * Accepts either a UUID or a document number (e.g. `PC-000042-RP`).
 */
export const getDocumentContainerOptions = (options: Options<GetDocumentContainerData>) => queryOptions<GetDocumentContainerResponse, AxiosError<DefaultError>, GetDocumentContainerResponse, ReturnType<typeof getDocumentContainerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDocumentContainer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDocumentContainerQueryKey(options)
});

/**
 * Update a document container.
 */
export const updateDocumentContainerMutation = (options?: Partial<Options<UpdateDocumentContainerData>>): UseMutationOptions<UpdateDocumentContainerResponse, AxiosError<DefaultError>, Options<UpdateDocumentContainerData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentContainerResponse, AxiosError<DefaultError>, Options<UpdateDocumentContainerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDocumentContainer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark the latest approved document version as obsolete.
 *
 * Sets the latest APPROVED version to OBSOLETE and regenerates the PDF
 * with an "OBSOLETE" watermark. Requires write permission on the container.
 */
export const obsoleteDocumentMutation = (options?: Partial<Options<ObsoleteDocumentData>>): UseMutationOptions<ObsoleteDocumentResponse, AxiosError<DefaultError>, Options<ObsoleteDocumentData>> => {
    const mutationOptions: UseMutationOptions<ObsoleteDocumentResponse, AxiosError<DefaultError>, Options<ObsoleteDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await obsoleteDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reinstate an obsolete document version back to approved.
 *
 * Sets the latest OBSOLETE version to APPROVED and regenerates the PDF
 * without a watermark. Requires write permission on the container.
 */
export const reinstateDocumentMutation = (options?: Partial<Options<ReinstateDocumentData>>): UseMutationOptions<ReinstateDocumentResponse, AxiosError<DefaultError>, Options<ReinstateDocumentData>> => {
    const mutationOptions: UseMutationOptions<ReinstateDocumentResponse, AxiosError<DefaultError>, Options<ReinstateDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reinstateDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload a file to a document container.
 *
 * If the latest document is a DRAFT, it is updated in-place.
 * Otherwise a new version is created.
 */
export const uploadDocumentMutation = (options?: Partial<Options<UploadDocumentData>>): UseMutationOptions<UploadDocumentResponse, AxiosError<DefaultError>, Options<UploadDocumentData>> => {
    const mutationOptions: UseMutationOptions<UploadDocumentResponse, AxiosError<DefaultError>, Options<UploadDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel a pending review.
 *
 * Deletes all pending reviews for the document and transitions it back to DRAFT.
 */
export const cancelReviewMutation = (options?: Partial<Options<CancelReviewData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CancelReviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<CancelReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Submit a review decision (approve or reject).
 *
 * On approval, marks previous approved versions in the same container as OBSOLETE.
 * On rejection, transitions the document back to DRAFT.
 */
export const submitReviewMutation = (options?: Partial<Options<SubmitReviewData>>): UseMutationOptions<SubmitReviewResponse, AxiosError<DefaultError>, Options<SubmitReviewData>> => {
    const mutationOptions: UseMutationOptions<SubmitReviewResponse, AxiosError<DefaultError>, Options<SubmitReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a document for review.
 *
 * Creates a review record and transitions the document from DRAFT to `IN_REVIEW`.
 */
export const sendForReviewMutation = (options?: Partial<Options<SendForReviewData>>): UseMutationOptions<SendForReviewResponse, AxiosError<DefaultError>, Options<SendForReviewData>> => {
    const mutationOptions: UseMutationOptions<SendForReviewResponse, AxiosError<DefaultError>, Options<SendForReviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendForReview({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a DRAFT document.
 *
 * Only works on DRAFT documents where an approved version exists in the
 * same container (i.e. the draft is a "new draft after approval").
 * Deletes any pending reviews first, then the document itself.
 */
export const deleteDraftMutation = (options?: Partial<Options<DeleteDraftData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteDraftData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteDraftData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDraft({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadOriginalQueryKey = (options: Options<DownloadOriginalData>) => createQueryKey('downloadOriginal', options);

/**
 * Download the original file of a document.
 */
export const downloadOriginalOptions = (options: Options<DownloadOriginalData>) => queryOptions<DownloadOriginalResponse, AxiosError<DefaultError>, DownloadOriginalResponse, ReturnType<typeof downloadOriginalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadOriginal({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadOriginalQueryKey(options)
});

export const downloadPdfQueryKey = (options: Options<DownloadPdfData>) => createQueryKey('downloadPdf', options);

/**
 * Download the generated PDF of a document.
 */
export const downloadPdfOptions = (options: Options<DownloadPdfData>) => queryOptions<DownloadPdfResponse, AxiosError<DefaultError>, DownloadPdfResponse, ReturnType<typeof downloadPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadPdfQueryKey(options)
});

/**
 * Regenerate the PDF for a document.
 *
 * Useful for retrying after a failed generation or forcing a refresh.
 */
export const regeneratePdfMutation = (options?: Partial<Options<RegeneratePdfData>>): UseMutationOptions<RegeneratePdfResponse, AxiosError<DefaultError>, Options<RegeneratePdfData>> => {
    const mutationOptions: UseMutationOptions<RegeneratePdfResponse, AxiosError<DefaultError>, Options<RegeneratePdfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regeneratePdf({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update document status.
 *
 * Valid transitions:
 * - DRAFT → `IN_REVIEW`
 * - `IN_REVIEW` → DRAFT (rejection)
 */
export const updateDocumentStatusMutation = (options?: Partial<Options<UpdateDocumentStatusData>>): UseMutationOptions<UpdateDocumentStatusResponse, AxiosError<DefaultError>, Options<UpdateDocumentStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateDocumentStatusResponse, AxiosError<DefaultError>, Options<UpdateDocumentStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDocumentStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Bulk download documents as a zip file (streaming).
 *
 * Accepts container IDs and/or folder IDs. For a single file with a single
 * format, returns the raw file directly (no zip wrapper).
 *
 * The zip is streamed via `tokio::io::duplex` — one file is loaded from the
 * database at a time and written to the zip stream, keeping memory usage low.
 */
export const bulkDownloadMutation = (options?: Partial<Options<BulkDownloadData>>): UseMutationOptions<BulkDownloadResponse, AxiosError<DefaultError>, Options<BulkDownloadData>> => {
    const mutationOptions: UseMutationOptions<BulkDownloadResponse, AxiosError<DefaultError>, Options<BulkDownloadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await bulkDownload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEcrsQueryKey = (options?: Options<ListEcrsData>) => createQueryKey('listEcrs', options);

/**
 * List ECRs with pagination, search, and filters.
 */
export const listEcrsOptions = (options?: Options<ListEcrsData>) => queryOptions<ListEcrsResponse, AxiosError<DefaultError>, ListEcrsResponse, ReturnType<typeof listEcrsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEcrs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEcrsQueryKey(options)
});

export const listEcrsInfiniteQueryKey = (options?: Options<ListEcrsData>): QueryKey<Options<ListEcrsData>> => createQueryKey('listEcrs', options, true);

/**
 * List ECRs with pagination, search, and filters.
 */
export const listEcrsInfiniteOptions = (options?: Options<ListEcrsData>) => infiniteQueryOptions<ListEcrsResponse, AxiosError<DefaultError>, InfiniteData<ListEcrsResponse>, QueryKey<Options<ListEcrsData>>, number | Pick<QueryKey<Options<ListEcrsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListEcrsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listEcrs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEcrsInfiniteQueryKey(options)
});

/**
 * Create a new ECR.
 */
export const createEcrMutation = (options?: Partial<Options<CreateEcrData>>): UseMutationOptions<CreateEcrResponse, AxiosError<DefaultError>, Options<CreateEcrData>> => {
    const mutationOptions: UseMutationOptions<CreateEcrResponse, AxiosError<DefaultError>, Options<CreateEcrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createEcr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEcrDashboardQueryKey = (options?: Options<GetEcrDashboardData>) => createQueryKey('getEcrDashboard', options);

/**
 * Get ECR dashboard data.
 */
export const getEcrDashboardOptions = (options?: Options<GetEcrDashboardData>) => queryOptions<GetEcrDashboardResponse, AxiosError<DefaultError>, GetEcrDashboardResponse, ReturnType<typeof getEcrDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEcrDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEcrDashboardQueryKey(options)
});

export const getEcrExportQueryKey = (options?: Options<GetEcrExportData>) => createQueryKey('getEcrExport', options);

/**
 * Export ECRs as CSV or JSON.
 */
export const getEcrExportOptions = (options?: Options<GetEcrExportData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getEcrExportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEcrExport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEcrExportQueryKey(options)
});

export const getEcrQueryKey = (options: Options<GetEcrData>) => createQueryKey('getEcr', options);

/**
 * Get ECR detail with history.
 */
export const getEcrOptions = (options: Options<GetEcrData>) => queryOptions<GetEcrResponse, AxiosError<DefaultError>, GetEcrResponse, ReturnType<typeof getEcrQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEcr({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEcrQueryKey(options)
});

/**
 * Update ECR fields with diff tracking.
 */
export const updateEcrMutation = (options?: Partial<Options<UpdateEcrData>>): UseMutationOptions<UpdateEcrResponse, AxiosError<DefaultError>, Options<UpdateEcrData>> => {
    const mutationOptions: UseMutationOptions<UpdateEcrResponse, AxiosError<DefaultError>, Options<UpdateEcrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEcr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Advance ECR through workflow stages.
 */
export const advanceEcrMutation = (options?: Partial<Options<AdvanceEcrData>>): UseMutationOptions<AdvanceEcrResponse, AxiosError<DefaultError>, Options<AdvanceEcrData>> => {
    const mutationOptions: UseMutationOptions<AdvanceEcrResponse, AxiosError<DefaultError>, Options<AdvanceEcrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await advanceEcr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listEcrHistoryQueryKey = (options: Options<ListEcrHistoryData>) => createQueryKey('listEcrHistory', options);

/**
 * List history entries for an ECR (newest first).
 */
export const listEcrHistoryOptions = (options: Options<ListEcrHistoryData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof listEcrHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listEcrHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEcrHistoryQueryKey(options)
});

export const listEcrHistoryInfiniteQueryKey = (options: Options<ListEcrHistoryData>): QueryKey<Options<ListEcrHistoryData>> => createQueryKey('listEcrHistory', options, true);

/**
 * List history entries for an ECR (newest first).
 */
export const listEcrHistoryInfiniteOptions = (options: Options<ListEcrHistoryData>) => infiniteQueryOptions<unknown, AxiosError<DefaultError>, InfiniteData<unknown>, QueryKey<Options<ListEcrHistoryData>>, number | Pick<QueryKey<Options<ListEcrHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListEcrHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listEcrHistory({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listEcrHistoryInfiniteQueryKey(options)
});

/**
 * Add a note to an ECR's history.
 */
export const addEcrNoteMutation = (options?: Partial<Options<AddEcrNoteData>>): UseMutationOptions<AddEcrNoteResponse, AxiosError<DefaultError>, Options<AddEcrNoteData>> => {
    const mutationOptions: UseMutationOptions<AddEcrNoteResponse, AxiosError<DefaultError>, Options<AddEcrNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addEcrNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEcrPdfQueryKey = (options: Options<GetEcrPdfData>) => createQueryKey('getEcrPdf', options);

/**
 * Export a single ECR as PDF via Gotenberg.
 */
export const getEcrPdfOptions = (options: Options<GetEcrPdfData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getEcrPdfQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEcrPdf({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEcrPdfQueryKey(options)
});

/**
 * Reclassify an ECR (admin only, `IN_REVIEW` only).
 */
export const reclassifyEcrMutation = (options?: Partial<Options<ReclassifyEcrData>>): UseMutationOptions<ReclassifyEcrResponse, AxiosError<DefaultError>, Options<ReclassifyEcrData>> => {
    const mutationOptions: UseMutationOptions<ReclassifyEcrResponse, AxiosError<DefaultError>, Options<ReclassifyEcrData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reclassifyEcr({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRootFoldersQueryKey = (options?: Options<ListRootFoldersData>) => createQueryKey('listRootFolders', options);

/**
 * List folders (paginated).
 *
 * By default returns only top-level folders (those with no parent).
 * Pass `include_nested=true` to return all folders in the system.
 */
export const listRootFoldersOptions = (options?: Options<ListRootFoldersData>) => queryOptions<ListRootFoldersResponse, AxiosError<DefaultError>, ListRootFoldersResponse, ReturnType<typeof listRootFoldersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRootFolders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRootFoldersQueryKey(options)
});

export const listRootFoldersInfiniteQueryKey = (options?: Options<ListRootFoldersData>): QueryKey<Options<ListRootFoldersData>> => createQueryKey('listRootFolders', options, true);

/**
 * List folders (paginated).
 *
 * By default returns only top-level folders (those with no parent).
 * Pass `include_nested=true` to return all folders in the system.
 */
export const listRootFoldersInfiniteOptions = (options?: Options<ListRootFoldersData>) => infiniteQueryOptions<ListRootFoldersResponse, AxiosError<DefaultError>, InfiniteData<ListRootFoldersResponse>, QueryKey<Options<ListRootFoldersData>>, number | Pick<QueryKey<Options<ListRootFoldersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListRootFoldersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listRootFolders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRootFoldersInfiniteQueryKey(options)
});

/**
 * Create a new folder.
 *
 * Creates a folder at root level or under an existing parent folder.
 * Name must be unique within the same parent (case-insensitive).
 */
export const createFolderMutation = (options?: Partial<Options<CreateFolderData>>): UseMutationOptions<CreateFolderResponse, AxiosError<DefaultError>, Options<CreateFolderData>> => {
    const mutationOptions: UseMutationOptions<CreateFolderResponse, AxiosError<DefaultError>, Options<CreateFolderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFolder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an empty folder.
 *
 * Fails if the folder contains subfolders or document containers.
 */
export const deleteFolderMutation = (options?: Partial<Options<DeleteFolderData>>): UseMutationOptions<DeleteFolderResponse, AxiosError<DefaultError>, Options<DeleteFolderData>> => {
    const mutationOptions: UseMutationOptions<DeleteFolderResponse, AxiosError<DefaultError>, Options<DeleteFolderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFolder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFolderContentsQueryKey = (options: Options<GetFolderContentsData>) => createQueryKey('getFolderContents', options);

/**
 * Get folder contents.
 *
 * Returns the folder details along with paginated subfolders, paginated
 * document containers, and breadcrumb navigation. Uses standard `ListParams`
 * for server-side search, sorting, and pagination of both collections.
 */
export const getFolderContentsOptions = (options: Options<GetFolderContentsData>) => queryOptions<GetFolderContentsResponse, AxiosError<DefaultError>, GetFolderContentsResponse, ReturnType<typeof getFolderContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFolderContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFolderContentsQueryKey(options)
});

export const getFolderContentsInfiniteQueryKey = (options: Options<GetFolderContentsData>): QueryKey<Options<GetFolderContentsData>> => createQueryKey('getFolderContents', options, true);

/**
 * Get folder contents.
 *
 * Returns the folder details along with paginated subfolders, paginated
 * document containers, and breadcrumb navigation. Uses standard `ListParams`
 * for server-side search, sorting, and pagination of both collections.
 */
export const getFolderContentsInfiniteOptions = (options: Options<GetFolderContentsData>) => infiniteQueryOptions<GetFolderContentsResponse, AxiosError<DefaultError>, InfiniteData<GetFolderContentsResponse>, QueryKey<Options<GetFolderContentsData>>, number | Pick<QueryKey<Options<GetFolderContentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetFolderContentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getFolderContents({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFolderContentsInfiniteQueryKey(options)
});

/**
 * Rename a folder.
 *
 * Name must be unique within the same parent (case-insensitive).
 */
export const renameFolderMutation = (options?: Partial<Options<RenameFolderData>>): UseMutationOptions<RenameFolderResponse, AxiosError<DefaultError>, Options<RenameFolderData>> => {
    const mutationOptions: UseMutationOptions<RenameFolderResponse, AxiosError<DefaultError>, Options<RenameFolderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renameFolder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccessibleUserIdsQueryKey = (options: Options<GetAccessibleUserIdsData>) => createQueryKey('getAccessibleUserIds', options);

/**
 * List user IDs that have at least Read access to a folder.
 *
 * Includes system admins, system viewers, and users with explicit folder
 * permissions (read or write). Useful for filtering reviewer selection.
 */
export const getAccessibleUserIdsOptions = (options: Options<GetAccessibleUserIdsData>) => queryOptions<GetAccessibleUserIdsResponse, AxiosError<DefaultError>, GetAccessibleUserIdsResponse, ReturnType<typeof getAccessibleUserIdsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccessibleUserIds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccessibleUserIdsQueryKey(options)
});

/**
 * Move a folder to a new parent.
 *
 * Validates that the move doesn't create a circular reference.
 * Set `parent_folder_id` to `null` to move to root.
 */
export const moveFolderMutation = (options?: Partial<Options<MoveFolderData>>): UseMutationOptions<MoveFolderResponse, AxiosError<DefaultError>, Options<MoveFolderData>> => {
    const mutationOptions: UseMutationOptions<MoveFolderResponse, AxiosError<DefaultError>, Options<MoveFolderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveFolder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke permissions from a user (admin only).
 *
 * Revokes one or more permissions in bulk. Permissions that do not exist
 * are silently ignored.
 */
export const revokePermissionsMutation = (options?: Partial<Options<RevokePermissionsData>>): UseMutationOptions<RevokePermissionsResponse, AxiosError<DefaultError>, Options<RevokePermissionsData>> => {
    const mutationOptions: UseMutationOptions<RevokePermissionsResponse, AxiosError<DefaultError>, Options<RevokePermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokePermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPermissionsQueryKey = (options?: Options<ListPermissionsData>) => createQueryKey('listPermissions', options);

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissionsOptions = (options?: Options<ListPermissionsData>) => queryOptions<ListPermissionsResponse, AxiosError<DefaultError>, ListPermissionsResponse, ReturnType<typeof listPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPermissionsQueryKey(options)
});

export const listPermissionsInfiniteQueryKey = (options?: Options<ListPermissionsData>): QueryKey<Options<ListPermissionsData>> => createQueryKey('listPermissions', options, true);

/**
 * List all permissions (paginated, admin only).
 *
 * Returns a paginated list of all permission records in the system.
 */
export const listPermissionsInfiniteOptions = (options?: Options<ListPermissionsData>) => infiniteQueryOptions<ListPermissionsResponse, AxiosError<DefaultError>, InfiniteData<ListPermissionsResponse>, QueryKey<Options<ListPermissionsData>>, number | Pick<QueryKey<Options<ListPermissionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPermissionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPermissions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPermissionsInfiniteQueryKey(options)
});

/**
 * Grant permissions to a user (admin only).
 *
 * Grants one or more permissions in bulk. Permissions that already exist
 * are skipped and reported in the `already_exists` field.
 */
export const grantPermissionsMutation = (options?: Partial<Options<GrantPermissionsData>>): UseMutationOptions<GrantPermissionsResponse, AxiosError<DefaultError>, Options<GrantPermissionsData>> => {
    const mutationOptions: UseMutationOptions<GrantPermissionsResponse, AxiosError<DefaultError>, Options<GrantPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await grantPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check a user's permissions (admin only).
 *
 * Checks one or more permission checks for a user and returns
 * whether each is allowed.
 */
export const checkPermissionsMutation = (options?: Partial<Options<CheckPermissionsData>>): UseMutationOptions<CheckPermissionsResponse, AxiosError<DefaultError>, Options<CheckPermissionsData>> => {
    const mutationOptions: UseMutationOptions<CheckPermissionsResponse, AxiosError<DefaultError>, Options<CheckPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserPermissionsQueryKey = (options: Options<GetUserPermissionsData>) => createQueryKey('getUserPermissions', options);

/**
 * Get a user's permission summary (admin only).
 *
 * Returns all permissions for a specific user plus whether they are a system admin.
 */
export const getUserPermissionsOptions = (options: Options<GetUserPermissionsData>) => queryOptions<GetUserPermissionsResponse, AxiosError<DefaultError>, GetUserPermissionsResponse, ReturnType<typeof getUserPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUserPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserPermissionsQueryKey(options)
});

export const getAccessibleResourcesQueryKey = (options: Options<GetAccessibleResourcesData>) => createQueryKey('getAccessibleResources', options);

/**
 * Get accessible resources for a user (admin only).
 *
 * Returns all resource IDs a user can access for a given resource type.
 */
export const getAccessibleResourcesOptions = (options: Options<GetAccessibleResourcesData>) => queryOptions<GetAccessibleResourcesResponse, AxiosError<DefaultError>, GetAccessibleResourcesResponse, ReturnType<typeof getAccessibleResourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccessibleResources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccessibleResourcesQueryKey(options)
});

/**
 * Create a purchase order PDF and file it in DMS.
 */
export const createPurchaseOrderMutation = (options?: Partial<Options<CreatePurchaseOrderData>>): UseMutationOptions<CreatePurchaseOrderResponse, AxiosError<DefaultError>, Options<CreatePurchaseOrderData>> => {
    const mutationOptions: UseMutationOptions<CreatePurchaseOrderResponse, AxiosError<DefaultError>, Options<CreatePurchaseOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPurchaseOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a preview PO PDF (with PREVIEW watermark).
 */
export const previewPurchaseOrderMutation = (options?: Partial<Options<PreviewPurchaseOrderData>>): UseMutationOptions<PreviewPurchaseOrderResponse, AxiosError<DefaultError>, Options<PreviewPurchaseOrderData>> => {
    const mutationOptions: UseMutationOptions<PreviewPurchaseOrderResponse, AxiosError<DefaultError>, Options<PreviewPurchaseOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewPurchaseOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSettingsQueryKey = (options?: Options<GetSettingsData>) => createQueryKey('getSettings', options);

/**
 * Get purchasing settings (creates singleton if not found).
 */
export const getSettingsOptions = (options?: Options<GetSettingsData>) => queryOptions<GetSettingsResponse, AxiosError<DefaultError>, GetSettingsResponse, ReturnType<typeof getSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSettingsQueryKey(options)
});

/**
 * Update purchasing settings.
 */
export const updateSettingsMutation = (options?: Partial<Options<UpdateSettingsData>>): UseMutationOptions<UpdateSettingsResponse, AxiosError<DefaultError>, Options<UpdateSettingsData>> => {
    const mutationOptions: UseMutationOptions<UpdateSettingsResponse, AxiosError<DefaultError>, Options<UpdateSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete company logo.
 */
export const deleteLogoMutation = (options?: Partial<Options<DeleteLogoData>>): UseMutationOptions<DeleteLogoResponse, AxiosError<DefaultError>, Options<DeleteLogoData>> => {
    const mutationOptions: UseMutationOptions<DeleteLogoResponse, AxiosError<DefaultError>, Options<DeleteLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLogoQueryKey = (options?: Options<GetLogoData>) => createQueryKey('getLogo', options);

/**
 * Get company logo image.
 */
export const getLogoOptions = (options?: Options<GetLogoData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof getLogoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLogo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLogoQueryKey(options)
});

/**
 * Upload company logo (multipart, max 2MB, image/png, image/jpeg, image/svg+xml).
 */
export const uploadLogoMutation = (options?: Partial<Options<UploadLogoData>>): UseMutationOptions<UploadLogoResponse, AxiosError<DefaultError>, Options<UploadLogoData>> => {
    const mutationOptions: UseMutationOptions<UploadLogoResponse, AxiosError<DefaultError>, Options<UploadLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPendingReviewsQueryKey = (options?: Options<ListPendingReviewsData>) => createQueryKey('listPendingReviews', options);

/**
 * List pending reviews assigned to the current user.
 */
export const listPendingReviewsOptions = (options?: Options<ListPendingReviewsData>) => queryOptions<ListPendingReviewsResponse, AxiosError<DefaultError>, ListPendingReviewsResponse, ReturnType<typeof listPendingReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPendingReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPendingReviewsQueryKey(options)
});

export const searchQueryKey = (options?: Options<SearchData>) => createQueryKey('search', options);

/**
 * Search document containers using hybrid full-text + trigram + ILIKE.
 */
export const searchOptions = (options?: Options<SearchData>) => queryOptions<SearchResponse, AxiosError<DefaultError>, SearchResponse, ReturnType<typeof searchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await search({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchQueryKey(options)
});

export const searchInfiniteQueryKey = (options?: Options<SearchData>): QueryKey<Options<SearchData>> => createQueryKey('search', options, true);

/**
 * Search document containers using hybrid full-text + trigram + ILIKE.
 */
export const searchInfiniteOptions = (options?: Options<SearchData>) => infiniteQueryOptions<SearchResponse, AxiosError<DefaultError>, InfiniteData<SearchResponse>, QueryKey<Options<SearchData>>, number | Pick<QueryKey<Options<SearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<SearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await search({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchInfiniteQueryKey(options)
});

export const listSuppliersQueryKey = (options?: Options<ListSuppliersData>) => createQueryKey('listSuppliers', options);

/**
 * List suppliers with pagination, search, and filters.
 */
export const listSuppliersOptions = (options?: Options<ListSuppliersData>) => queryOptions<ListSuppliersResponse, AxiosError<DefaultError>, ListSuppliersResponse, ReturnType<typeof listSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSuppliersQueryKey(options)
});

export const listSuppliersInfiniteQueryKey = (options?: Options<ListSuppliersData>): QueryKey<Options<ListSuppliersData>> => createQueryKey('listSuppliers', options, true);

/**
 * List suppliers with pagination, search, and filters.
 */
export const listSuppliersInfiniteOptions = (options?: Options<ListSuppliersData>) => infiniteQueryOptions<ListSuppliersResponse, AxiosError<DefaultError>, InfiniteData<ListSuppliersResponse>, QueryKey<Options<ListSuppliersData>>, number | Pick<QueryKey<Options<ListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSuppliers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSuppliersInfiniteQueryKey(options)
});

/**
 * Create a new supplier.
 */
export const createSupplierMutation = (options?: Partial<Options<CreateSupplierData>>): UseMutationOptions<CreateSupplierResponse, AxiosError<DefaultError>, Options<CreateSupplierData>> => {
    const mutationOptions: UseMutationOptions<CreateSupplierResponse, AxiosError<DefaultError>, Options<CreateSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const suggestCodeQueryKey = (options: Options<SuggestCodeData>) => createQueryKey('suggestCode', options);

/**
 * Suggest a supplier code based on the supplier name.
 */
export const suggestCodeOptions = (options: Options<SuggestCodeData>) => queryOptions<SuggestCodeResponse2, AxiosError<DefaultError>, SuggestCodeResponse2, ReturnType<typeof suggestCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await suggestCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: suggestCodeQueryKey(options)
});

/**
 * Delete a supplier (admin only).
 */
export const deleteSupplierMutation = (options?: Partial<Options<DeleteSupplierData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteSupplierData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSupplierQueryKey = (options: Options<GetSupplierData>) => createQueryKey('getSupplier', options);

/**
 * Get supplier detail with notes and history.
 */
export const getSupplierOptions = (options: Options<GetSupplierData>) => queryOptions<GetSupplierResponse, AxiosError<DefaultError>, GetSupplierResponse, ReturnType<typeof getSupplierQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSupplier({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSupplierQueryKey(options)
});

/**
 * Update a supplier with automatic change history.
 */
export const updateSupplierMutation = (options?: Partial<Options<UpdateSupplierData>>): UseMutationOptions<UpdateSupplierResponse, AxiosError<DefaultError>, Options<UpdateSupplierData>> => {
    const mutationOptions: UseMutationOptions<UpdateSupplierResponse, AxiosError<DefaultError>, Options<UpdateSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a note to a supplier.
 */
export const addNote2Mutation = (options?: Partial<Options<AddNote2Data>>): UseMutationOptions<AddNote2Response, AxiosError<DefaultError>, Options<AddNote2Data>> => {
    const mutationOptions: UseMutationOptions<AddNote2Response, AxiosError<DefaultError>, Options<AddNote2Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addNote2({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a supplier note.
 */
export const deleteNoteMutation = (options?: Partial<Options<DeleteNoteData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteNoteData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeleteNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit a supplier note.
 */
export const editNoteMutation = (options?: Partial<Options<EditNoteData>>): UseMutationOptions<EditNoteResponse, AxiosError<DefaultError>, Options<EditNoteData>> => {
    const mutationOptions: UseMutationOptions<EditNoteResponse, AxiosError<DefaultError>, Options<EditNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActiveUsersQueryKey = (options?: Options<ListActiveUsersData>) => createQueryKey('listActiveUsers', options);

/**
 * List active users for dropdowns (e.g. reviewer selection).
 *
 * Returns all active users with id and name. Available to any authenticated user.
 */
export const listActiveUsersOptions = (options?: Options<ListActiveUsersData>) => queryOptions<ListActiveUsersResponse, AxiosError<DefaultError>, ListActiveUsersResponse, ReturnType<typeof listActiveUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveUsersQueryKey(options)
});

/**
 * Update the current user's profile.
 *
 * Allows updating name and/or email. Email must be unique across all users.
 */
export const updateProfileMutation = (options?: Partial<Options<UpdateProfileData>>): UseMutationOptions<UpdateProfileResponse, AxiosError<DefaultError>, Options<UpdateProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateProfileResponse, AxiosError<DefaultError>, Options<UpdateProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Disable two-factor authentication.
 *
 * Requires a valid TOTP code for security verification before disabling.
 */
export const disable2FaMutation = (options?: Partial<Options<Disable2FaData>>): UseMutationOptions<Disable2FaResponse, AxiosError<DefaultError>, Options<Disable2FaData>> => {
    const mutationOptions: UseMutationOptions<Disable2FaResponse, AxiosError<DefaultError>, Options<Disable2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disable2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enable two-factor authentication.
 *
 * Requires a valid TOTP code from the authenticator app to confirm
 * the secret was correctly set up.
 */
export const enable2FaMutation = (options?: Partial<Options<Enable2FaData>>): UseMutationOptions<Enable2FaResponse, AxiosError<DefaultError>, Options<Enable2FaData>> => {
    const mutationOptions: UseMutationOptions<Enable2FaResponse, AxiosError<DefaultError>, Options<Enable2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await enable2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate a TOTP secret for 2FA setup.
 *
 * Returns the secret and a provisioning URI for QR code generation.
 * The secret is stored but 2FA is not enabled until confirmed with
 * `POST /2fa/enable`.
 */
export const generate2FaMutation = (options?: Partial<Options<Generate2FaData>>): UseMutationOptions<Generate2FaResponse, AxiosError<DefaultError>, Options<Generate2FaData>> => {
    const mutationOptions: UseMutationOptions<Generate2FaResponse, AxiosError<DefaultError>, Options<Generate2FaData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await generate2Fa({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyAccessibleResourcesQueryKey = (options: Options<GetMyAccessibleResourcesData>) => createQueryKey('getMyAccessibleResources', options);

/**
 * Get the current user's accessible resources for a given type.
 *
 * Returns all resource IDs the authenticated user has permissions on
 * for the requested resource type.
 */
export const getMyAccessibleResourcesOptions = (options: Options<GetMyAccessibleResourcesData>) => queryOptions<GetMyAccessibleResourcesResponse, AxiosError<DefaultError>, GetMyAccessibleResourcesResponse, ReturnType<typeof getMyAccessibleResourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyAccessibleResources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyAccessibleResourcesQueryKey(options)
});

export const listPasskeysQueryKey = (options?: Options<ListPasskeysData>) => createQueryKey('listPasskeys', options);

/**
 * List the current user's registered passkeys.
 */
export const listPasskeysOptions = (options?: Options<ListPasskeysData>) => queryOptions<ListPasskeysResponse, AxiosError<DefaultError>, ListPasskeysResponse, ReturnType<typeof listPasskeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPasskeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPasskeysQueryKey(options)
});

/**
 * Complete passkey registration.
 *
 * Verifies the credential response and stores the passkey in the database.
 */
export const registerFinishMutation = (options?: Partial<Options<RegisterFinishData>>): UseMutationOptions<RegisterFinishResponse, AxiosError<DefaultError>, Options<RegisterFinishData>> => {
    const mutationOptions: UseMutationOptions<RegisterFinishResponse, AxiosError<DefaultError>, Options<RegisterFinishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerFinish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start passkey registration.
 *
 * Returns `WebAuthn` creation options that the browser passes to
 * `navigator.credentials.create()`. Challenge state is stored in the cache.
 */
export const registerStartMutation = (options?: Partial<Options<RegisterStartData>>): UseMutationOptions<RegisterStartResponse2, AxiosError<DefaultError>, Options<RegisterStartData>> => {
    const mutationOptions: UseMutationOptions<RegisterStartResponse2, AxiosError<DefaultError>, Options<RegisterStartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await registerStart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a registered passkey.
 */
export const deletePasskeyMutation = (options?: Partial<Options<DeletePasskeyData>>): UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeletePasskeyData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DefaultError>, Options<DeletePasskeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePasskey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change the current user's password.
 *
 * Requires the current password for verification. The new password must
 * meet strength requirements (uppercase, lowercase, digit, special character).
 */
export const changePasswordMutation = (options?: Partial<Options<ChangePasswordData>>): UseMutationOptions<ChangePasswordResponse, AxiosError<DefaultError>, Options<ChangePasswordData>> => {
    const mutationOptions: UseMutationOptions<ChangePasswordResponse, AxiosError<DefaultError>, Options<ChangePasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await changePassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMyPermissionsQueryKey = (options?: Options<GetMyPermissionsData>) => createQueryKey('getMyPermissions', options);

/**
 * Get the current user's permission summary.
 *
 * Returns all direct and inherited permissions for the authenticated user.
 */
export const getMyPermissionsOptions = (options?: Options<GetMyPermissionsData>) => queryOptions<GetMyPermissionsResponse, AxiosError<DefaultError>, GetMyPermissionsResponse, ReturnType<typeof getMyPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyPermissionsQueryKey(options)
});

/**
 * Check multiple permissions for the current user.
 *
 * Returns whether each requested permission is granted and the source
 * of the grant (system admin, direct grant, or inherited from parent).
 */
export const checkMyPermissionsMutation = (options?: Partial<Options<CheckMyPermissionsData>>): UseMutationOptions<CheckMyPermissionsResponse, AxiosError<DefaultError>, Options<CheckMyPermissionsData>> => {
    const mutationOptions: UseMutationOptions<CheckMyPermissionsResponse, AxiosError<DefaultError>, Options<CheckMyPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkMyPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const healthQueryKey = (options?: Options<HealthData>) => createQueryKey('health', options);

/**
 * Basic health check with database status.
 */
export const healthOptions = (options?: Options<HealthData>) => queryOptions<HealthResponse2, AxiosError<DefaultError>, HealthResponse2, ReturnType<typeof healthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await health({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthQueryKey(options)
});

export const healthDetailedQueryKey = (options?: Options<HealthDetailedData>) => createQueryKey('healthDetailed', options);

/**
 * Comprehensive health check with pool, latency, and DB metrics.
 */
export const healthDetailedOptions = (options?: Options<HealthDetailedData>) => queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof healthDetailedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthDetailed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthDetailedQueryKey(options)
});

export const liveQueryKey = (options?: Options<LiveData>) => createQueryKey('live', options);

/**
 * Kubernetes liveness probe.
 *
 * Always returns 200 — proves the process is running.
 * No dependency checks; use `/health/ready` for that.
 */
export const liveOptions = (options?: Options<LiveData>) => queryOptions<LiveResponse2, AxiosError<DefaultError>, LiveResponse2, ReturnType<typeof liveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await live({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: liveQueryKey(options)
});

export const readyQueryKey = (options?: Options<ReadyData>) => createQueryKey('ready', options);

/**
 * Kubernetes readiness probe.
 *
 * Checks database connectivity (`SELECT 1`).
 * Returns 200 if all dependencies are reachable, 503 otherwise.
 */
export const readyOptions = (options?: Options<ReadyData>) => queryOptions<ReadyResponse2, AxiosError<ReadyError>, ReadyResponse2, ReturnType<typeof readyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ready({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: readyQueryKey(options)
});

export const versionQueryKey = (options?: Options<VersionData>) => createQueryKey('version', options);

/**
 * Build version information.
 *
 * Returns the crate version, git commit SHA, and build date.
 * Commit and build date are set at compile time via environment variables.
 */
export const versionOptions = (options?: Options<VersionData>) => queryOptions<VersionResponse2, AxiosError<DefaultError>, VersionResponse2, ReturnType<typeof versionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await version({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: versionQueryKey(options)
});
